// Утилиты для работы с cookie согласием

export const getCookieConsent = () => {
  return localStorage.getItem('cookieConsent');
};

export const setCookieConsent = (consent) => {
  localStorage.setItem('cookieConsent', consent);
};

export const hasCookieConsent = () => {
  const consent = getCookieConsent();
  return consent === 'accepted';
};

export const hasDeclinedCookies = () => {
  const consent = getCookieConsent();
  return consent === 'declined';
};

export const clearCookieConsent = () => {
  localStorage.removeItem('cookieConsent');
};